
import { useEffect } from 'react';

const useFreshworksWidget = (widgetId, loadOnMount = false) => {
  useEffect(() => {
    if (!loadOnMount) return;

    // Set widget settings
    window.fwSettings = { widget_id: widgetId };

    // Create FreshworksWidget function if it doesn't exist
    if (typeof window.FreshworksWidget !== 'function') {
      const n = function() {
        n.q.push(arguments);
      };
      n.q = [];
      window.FreshworksWidget = n;
    }

    // Check if script already exists
    const existingScript = document.getElementById('freshworks-widget-script');
    
    if (!existingScript) {
      // Load the Freshworks script
      const script = document.createElement('script');
      script.id = 'freshworks-widget-script';
      script.type = 'text/javascript';
      script.src = `https://euc-widget.freshworks.com/widgets/${widgetId}.js`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } else {
      // If script exists, show the widget
      if (window.FreshworksWidget && typeof window.FreshworksWidget === 'function') {
        window.FreshworksWidget('open');
      }
    }

    // Cleanup function - CRITICAL FIX
    return () => {
      // Hide the widget instead of removing script
      if (window.FreshworksWidget && typeof window.FreshworksWidget === 'function') {
        try {
          window.FreshworksWidget('hide');
          
          // Also hide the widget container directly
          const widgetFrame = document.querySelector('#launcher-frame, [id*="freshworks"], [id*="freshchat"]');
          if (widgetFrame) {
            widgetFrame.style.display = 'none';
          }
        } catch (e) {
          console.warn('Error hiding Freshworks widget:', e);
        }
      }
      
      // Optional: Remove script if you want complete cleanup
      const script = document.getElementById('freshworks-widget-script');
      if (script) {
        document.body.removeChild(script);
        delete window.fwSettings;
        delete window.FreshworksWidget;
      }
    };
  }, [widgetId, loadOnMount]);

  const openWidget = () => {
    if (typeof window.FreshworksWidget === 'function') {
      window.FreshworksWidget('open');
    }
  };

  const hideWidget = () => {
    if (typeof window.FreshworksWidget === 'function') {
      try {
        window.FreshworksWidget('hide');
        
        // Also hide the widget container directly
        const widgetFrame = document.querySelector('#launcher-frame, [id*="freshworks"], [id*="freshchat"]');
        if (widgetFrame) {
          widgetFrame.style.display = 'none';
        }
      } catch (e) {
        console.warn('Error hiding Freshworks widget:', e);
      }
    }
  };

  return { openWidget, hideWidget };
};

export default useFreshworksWidget;